import { render, staticRenderFns } from "./px-questionary-range.vue?vue&type=template&id=32fbb198&scoped=true&"
import script from "./px-questionary-range.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-range.vue?vue&type=script&lang=ts&"
import style0 from "./px-questionary-range.vue?vue&type=style&index=0&id=32fbb198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbb198",
  null
  
)

export default component.exports